module.exports={
	"Form": "ProjectOfficeViewManifest",
	"Scope": "ProjectOffice-View",
	"Descriptors":
	{
		"ProjectOfficeDetails.OfficeCode":
		{
			"Name": "Office Code",
			"Hash": "ProjectOffice-View-OfficeCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectOffice-View-Identity",
				"Group": "ProjectOffice-View-Identity"
			}
		},
		"ProjectOfficeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProjectOffice-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectOffice-View-Identity",
				"Group": "ProjectOffice-View-Identity"
			}
		},
		"ProjectOfficeDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "ProjectOffice-View-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ProjectOffice-View-Contact",
				"Group": "ProjectOffice-View-Contact"
			}
		},
		"ProjectOfficeDetails.Address":
		{
			"Name": "Address",
			"Hash": "ProjectOffice-View-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "ProjectOffice-View-Address",
				"Group": "ProjectOffice-View-Address"
			}
		},
		"ProjectOfficeDetails.City":
		{
			"Name": "City",
			"Hash": "ProjectOffice-View-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-View-Address",
				"Group": "ProjectOffice-View-Address"
			}
		},
		"ProjectOfficeDetails.State":
		{
			"Name": "State",
			"Hash": "ProjectOffice-View-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-View-Address",
				"Group": "ProjectOffice-View-Address"
			}
		},
		"ProjectOfficeDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "ProjectOffice-View-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-View-Address",
				"Group": "ProjectOffice-View-Address"
			}
		},
		"ProjectOfficeDetails.IDProjectOffice":
		{
			"Name": "IDProject Office",
			"Hash": "ProjectOffice-View-IDProjectOffice",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		},
		"ProjectOfficeDetails.GUIDProjectOffice":
		{
			"Name": "GUIDProject Office",
			"Hash": "ProjectOffice-View-GUIDProjectOffice",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		},
		"ProjectOfficeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "ProjectOffice-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		},
		"ProjectOfficeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "ProjectOffice-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		},
		"ProjectOfficeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "ProjectOffice-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		},
		"ProjectOfficeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "ProjectOffice-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectOffice-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectOffice-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "ProjectOffice-View-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "ProjectOffice-View-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "ProjectOffice-View-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "ProjectOffice-View-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "ProjectOffice-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "ProjectOffice-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
